// How a ticket's state looks, in one place.
//
// Both screens show a status and a priority, and a badge whose colour means
// something different in the list from what it means in the thread is worse than
// no colour at all.

/** Badge variant per status. Only what is finished is green. */
export const STATUS_VARIANT = {
  new:            'info',
  open:           'primary',
  waiting_client: 'warning',
  resolved:       'success',
  closed:         'neutral',
}

/** Priority earns a colour only when it is above normal: everything urgent is nothing urgent. */
export const PRIORITY_VARIANT = {
  low:    'neutral',
  normal: 'neutral',
  high:   'warning',
  urgent: 'danger',
}

export const statusVariant = (status) => STATUS_VARIANT[status] ?? 'neutral'
export const priorityVariant = (priority) => PRIORITY_VARIANT[priority] ?? 'neutral'

/**
 * A system message is written by the backend as `status:from>to`, so a ticket
 * reopened in Spanish and read in French says the right thing in both. Anything
 * else in the body is a note somebody typed, and is shown as it was written.
 *
 * @returns {{from: string, to: string}|null}
 */
export function parseStatusNote(body) {
  const match = /^status:([a-z_]+)>([a-z_]+)$/.exec(String(body ?? '').trim())
  return match ? { from: match[1], to: match[2] } : null
}
